import { Box, ImageListItem, ImageListItemBar } from "@mui/material";
import React from "react";
import { ETextureOrigin, IAssetTexture } from "../../@types/ContextProviderRelated";
import { EInteractionMode } from "../../@types/Enums";
import { EAssetType, IFilesApiMaterial } from "../../@types/FilesAPIModels";
import { useBuilding } from "../../provider/BuildingProvider/BuildingProvider";
import { useToolbarContext } from "../../provider/ToolbarProvider";
import { loadMaterialTexture } from "../../utils/textureLoaderUtility";

interface MaterialImageListItemProps {
  material: IFilesApiMaterial;
  index: number;
}

const MaterialImageListItem: React.FC<MaterialImageListItemProps> = ({ material }) => {
  const { setSelectedTexture, getSelectedModel: getSelectedObject, applyTextureToStoredObject } = useBuilding();
  const { setInteractionMode } = useToolbarContext();

  const applyMaterial = async () => {
    try {
      // load the THREE.Texture for this standalone asset
      const threeTexture = await loadMaterialTexture(material.id);

      const textureInfo: IAssetTexture = {
        textureOrigin: ETextureOrigin.ASSET,
        id: material.id,      
        name: material.name,
        type: EAssetType.MATERIAL,
        material: threeTexture,
        color: undefined,
        rotation: 0,
        offset: 0,
      };

      const immediate = Boolean(getSelectedObject());
      if (immediate) {
        // apply right away
        setSelectedTexture(textureInfo, true);
        // next tick, actually assign and reset mode
        setTimeout(() => {
          applyTextureToStoredObject();
          setInteractionMode(EInteractionMode.NONE);
        }, 0);
      } else {
        // stash for later
        setSelectedTexture(textureInfo);
        setInteractionMode(EInteractionMode.SET_TEXTURE);
      }
    } catch (err) {
      console.error("Error loading material texture:", err);
    }
  };

  return (
    <ImageListItem
      key={`assetTexture-${material.id}`}
      sx={{
        width: "100px !important",
        height: "100px !important",
        cursor: "pointer",
        "& .MuiImageListItem-img": {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      }}
      onClick={applyMaterial}
    >
      {material.previewPictureUrl ? (
        <Box
          component="img"
          src={material.previewPictureUrl}
          alt={material.name}
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            color: "#4a4a4a",
          }}
        >
          No Preview
        </Box>
      )}
      <ImageListItemBar
        title={material.name}
        sx={{
          "& .MuiImageListItemBar-title": {
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      />
    </ImageListItem>
  );
};

export default MaterialImageListItem;
